import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import '@/style/common.css'
import { store } from './store/index'
import '@/utils/commonFun.js'

Vue.config.productionTip = false
Vue.use(Antd)

new Vue({
  router,
  render: h => h(App),
  store: store
}).$mount('#app')
